import { render, staticRenderFns } from "./replyBackStatus.vue?vue&type=template&id=52d7d59d&scoped=true"
import script from "./replyBackStatus.vue?vue&type=script&lang=js"
export * from "./replyBackStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7d59d",
  null
  
)

export default component.exports